import { useEffect } from "react";

export function useDisableDefaultDropEvent(ref: React.RefObject<HTMLElement | null>) {
  useEffect(() => {
    const handleDrop = (e: DragEvent) => {
      e.preventDefault();
    };
    const handleDragOver = (e: DragEvent) => {
      e.preventDefault();
    };
    if (ref.current) {
      ref.current.addEventListener("drop", handleDrop);
      ref.current.addEventListener("dragover", handleDragOver);
    }
    return () => {
      if (ref.current) {
        ref.current.removeEventListener("drop", handleDrop);
        ref.current.removeEventListener("dragover", handleDragOver);
      }
    };
  }, [ref]);
}
